import { SearchFilters, SearchQueryState } from "../../../interfaces/state/searchQuery";
import { calculateNumberOfFilterSelected } from "../../../components/categoryBar/filterBtn/calculateNumberOfFilterSelected";

export const parseLocationString = (location: string): string => {
    const newLocations = location.split("-");
    return newLocations.map((newLocation) => newLocation.charAt(0).toUpperCase() + newLocation.slice(1).toLowerCase()).join(" ");
};

export const parseDateString = (dateString: string): Date => {
    // Support both yyyy-mm-dd (preferred) and dd-mm-yyyy (legacy)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const [yearStr, monthStr, dayStr] = dateString.split("-");
        const year = Number(yearStr);
        const month = Number(monthStr);
        const day = Number(dayStr);
        return new Date(year, month - 1, day);
    }
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
        const [dayStr, monthStr, yearStr] = dateString.split("-");
        const day = Number(dayStr);
        const month = Number(monthStr);
        const year = Number(yearStr);
        return new Date(year, month - 1, day);
    }
    // Fallback for ISO strings or timestamps
    return new Date(dateString);
};

// Safely coerce various inputs into a valid Date, or return null if invalid
const coerceToDate = (value: Date | string | number | null | undefined): Date | null => {
    if (!value) return null;
    if (value instanceof Date) {
        return isNaN(value.getTime()) ? null : value;
    }
    if (typeof value === "number") {
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d;
    }
    if (typeof value === "string") {
        // yyyy-mm-dd preferred, dd-mm-yyyy legacy
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            const [yearStr, monthStr, dayStr] = value.split("-");
            const d = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr));
            return isNaN(d.getTime()) ? null : d;
        }
        if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
            const [dayStr, monthStr, yearStr] = value.split("-");
            const d = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr));
            return isNaN(d.getTime()) ? null : d;
        }
        // Otherwise, fall back to native parsing (handles ISO strings)
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d;
    }
    return null;
};

export const formatDateForUrl = (dateLike: Date | string | number): string => {
    const date = coerceToDate(dateLike);
    if (!date) return "";
    // yyyy-mm-dd
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

// Legacy URL helpers removed: buildSearchUrl and updateSearchQueryFromUrl
